module.exports = __webpack_public_path__ + "static/media/phone.7fc0f20c.png";